import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { HeadingLevel } from '../../../subcomponents/heading/heading';
import { FilmThumbnail } from '../../film/thumbnail/film-thumbnail';
import { FilmTitle } from '../../film/title/film-title';
const b = bemClassBuilder('v-member-film-watchlist-film-details');
export const MemberFilmWatchlistFilmDetails = observer(props => {
    const { filmMediaType, cdnOptions } = props;
    return (_jsxs("div", Object.assign({ className: b.block() }, { children: [_jsx("div", Object.assign({ className: b.element('thumbnail') }, { children: _jsx(FilmThumbnail, { config: { mediaType: filmMediaType, showWatchlistButton: false }, events: {}, cdnOptions: cdnOptions }) })), _jsx(FilmTitle, { config: { headingLevel: HeadingLevel.H3 }, cdnOptions: cdnOptions })] })));
});
MemberFilmWatchlistFilmDetails.displayName = 'MemberFilmWatchlistFilmDetails';
